<nb-card>
  <nb-card-body>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <h6 class="text-primary link" (click)="viewDetail(remind.loan)">
            <nb-icon icon="person-outline"></nb-icon>
            {{ remind.loan.customerName }}
          </h6>

          <a
            *ngIf="remind.loan.customer?.mobile"
            class="text-hint link"
            href="tel:{{ remind.loan.customer.mobile }}"
          >
            <nb-icon icon="phone-call-outline"></nb-icon>
            {{ remind.loan.customer.mobile }}
          </a>

          <label *ngIf="remind.loan.customer?.address" class="text-hint">
            <nb-icon icon="map-outline"></nb-icon>
            {{ remind.loan.customer.address }}
          </label>
        </div>

        <div class="content">
          <h6 class="text-primary link" (click)="viewDetail(remind.loan)">
            <nb-icon icon="car-outline"></nb-icon>
            {{ remind.loan.productName }}
          </h6>

          <label *ngIf="remind.loan.product?.barcode" class="text-hint">
            <nb-icon icon="hash-outline"></nb-icon>
            {{ remind.loan.product.barcode }}
          </label>

          <label class="text-hint">
            <nb-icon icon="calendar-outline"></nb-icon>
            <span class="text-hint"> Ngày nhận: </span>
            <b>{{ remind.loan.issueDate | date : "dd/MM/yyyy" }}</b>
            <ngx-view-time-ago
              [currentDate]="remind.loan.issueDate"
            ></ngx-view-time-ago>

            (
            <span class="text-hint"
              >${{ remind.loan.detailAmount | number }}</span
            >
            )
          </label>

          <label [ngClass]="mode === 'completed' ? 'text-hint' : 'text-basic'">
            <nb-icon icon="calendar-outline"></nb-icon>
            <span> Ngày đáo hạn: </span>
            <b [ngClass]="mode === 'completed' ? 'text-hint' : 'text-basic'">{{
              remind.issueDate | date : "dd/MM/yyyy"
            }}</b>
            <ngx-view-time-ago
              [currentDate]="remind.issueDate"
            ></ngx-view-time-ago>

            (
            <!-- <span class="text-primary"
              >{{ remind.loan.remindPaidNumber | number }}
              {{ remind.loan.remindType }}
            </span> -->
            <span class="text-hint">{{ remindTypeName }} </span>
            )
          </label>

          <label *ngIf="mode === 'completed'" class="text-basic">
            <nb-icon icon="calendar-outline"></nb-icon>
            <span> Ngày thu: </span>
            <b class="text-basic">{{
              remind.paymentDate | date : "dd/MM/yyyy"
            }}</b>
            <ngx-view-time-ago
              [currentDate]="remind.paymentDate"
            ></ngx-view-time-ago>
          </label>

          <textarea
            nbInput
            fullWidth
            rows="1"
            class="form-control"
            placeholder="Nhập ghi chú"
            [(ngModel)]="remind.comment"
            [disabled]="remind.isPaid"
          ></textarea>

          <div [ngClass]="isMobile ? '' : 'button-actions'">
            <h6 *ngIf="remind.isPaid" class="text-hint">
              <nb-icon icon="pricetags-outline"></nb-icon> Tiền thu:
              <span class="text-info">{{ remind.amount | number }}</span>
            </h6>

            <input
              *ngIf="!remind.isPaid"
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              placeholder="Nhập số tiền"
              [status]="remind.amount > 0 ? 'primary' : 'danger'"
              [(ngModel)]="remind.amount"
              [ngxNumberFormat]="formatCurrency"
            />

            <button
              *ngIf="!remind.isPaid"
              nbButton
              shape="semi-round"
              hero
              status="success"
              size="small"
              (click)="payment()"
            >
              <nb-icon icon="checkmark-circle-outline"></nb-icon>
              <span *ngIf="!isMobile">Thanh toán</span>
            </button>

            <button
              nbButton
              shape="semi-round"
              outline
              status="danger"
              size="small"
              (click)="remove()"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
              <span *ngIf="!isMobile">Xóa</span>
            </button>
          </div>

          <!-- <div class="text-hint">
            <nb-icon icon="clock-outline"></nb-icon>
            <ngx-view-time-ago
              [currentDate]="remind.loan.issueDate"
            ></ngx-view-time-ago>
          </div>

          <a (click)="viewDetail(loan)" class="link text-link">
            <nb-icon icon="more-horizontal-outline"></nb-icon>
            Xem thêm
          </a> -->
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
